import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/static-data-lookup")({
  staticData: { breadcrumb: "Static Data" },
});
